export default "__VITE_ASSET__X1UZTZxr__"